const MemoryRouteNavigationOptions = {
  title: 'Memory',
  headerTitle: () => null,
  headerBackVisible: false,
};

export default MemoryRouteNavigationOptions;
